import { useHeaderContext } from '@jouzen/ecom-components/layout';
import { type ReactNode } from 'react';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import ProductSchema from '@/app/[locale]/store/_components/HardwarePDP/ProductSchema';
import useDiscountMessage from '@/app/components/PageLayout/_hooks/useDiscountMessage';

import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';

interface LayoutProps {
  readonly children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { currentRoute, currentStep, isAccessory, itemCountForIcon, product } =
    useWizardStateContext();
  const { displayMessage } = useDiscountMessage({
    gen3WizardConsumer: true,
    isAccessory,
  });
  const hasEyebrow = displayMessage !== null && !isAccessory;
  const headerContext = useHeaderContext();

  const inverseHeader = headerContext?.inverse;

  if (!currentRoute.isReady) return null;

  return (
    <>
      <ProductSchema product={product} />
      <DesktopLayout
        hasEyebrow={hasEyebrow}
        currentStep={currentStep}
        inverseHeader={inverseHeader}
        isAccessory={isAccessory}
        itemCountForIcon={itemCountForIcon}
      >
        {children}
      </DesktopLayout>
      <MobileLayout
        hasEyebrow={hasEyebrow}
        currentStep={currentStep}
        inverseHeader={inverseHeader}
        isAccessory={isAccessory}
        itemCountForIcon={itemCountForIcon}
      >
        {children}
      </MobileLayout>
    </>
  );
};

export default Layout;
